<template>
    <div>
        <div class="card ">
            <div class="card-header main-card">
                Administración de paradas y hoteles por grupos de actividades
            </div>
            <div class="d-flex justify-content-end my-4 mx-4">
                <div>
                    
                </div>
            </div>
            
            <div class="card-body">
                <div>
                    <div class="mb-4 d-flex">
                        <div class="flex mr-3">
                            <span class="mr-4" style="display:block">
                            Selecciona la zona
                            </span>
                            <b-form-select @change="trigger" v-model="suprazone_id" class="">
                                <option value="0">Seleccione zona...</option>
                                <option v-for="suprazone in suprazones" :key="suprazone.id" :value="suprazone.id">{{suprazone.name}}</option>
                            </b-form-select>
                        </div>
                        <div class="flex mx-3" v-if="suprazone_id != 0">
                            <span class="" style="display:block">
                                Filtrar por nombe
                            </span>
                            <b-form-input
                                v-model="filtering.filter_name"
                                
                                class="border" style="display:block; border-color: #999 !important;"
                            >

                            </b-form-input>
                        </div>
                        <div class="flex mx-3" v-if="suprazone_id != 0">
                            <span class="" style="display:block" >
                                Filtrar por resort
                            </span>
                            <b-form-select v-model="filtering.resort" class="">
                                <option value="0">Ver todos los resorts</option>
                                <optgroup v-for="(grp, idx) in grouping" :key="idx" :label="idx">
                                    <option v-for="item in grp" :key="item.id" :value="item.id">{{item.name}}</option>
                                </optgroup>
                            </b-form-select>
                            
                        </div>
                        <div class="flex mx-3" v-if="suprazone_id != 0">
                            <span class="" style="display:block" >
                                Ordenar
                            </span>
                            <b-form-select v-model="filtering.orderPoints" class="">
                                <!-- <option value="0">Seleccione orden...</option> -->
                                <option value="by_hotel_name">Ordenar por hotel (alfabético ASC)</option>
                                <option value="by_zone_name">Ordenar por resort (alfabético ASC)</option>
                            </b-form-select>
                            
                        </div>                      
                    </div>
                </div>
                <div v-if="suprazone_id != 0">
                    <p  class="text-center font-weight-bold">
                        Listado hoteles con su parada dependiendo del grupo de actividad de la zona {{suprazone != undefined ? suprazone.name : ''}}
                    </p>
                </div>
                <div>
                    <table class="table table-hover table-bordered table-sm mt-1 relative" id="admin-hotel-stop-groups">
                        <thead>
                            <tr>
                                <th>Hotel</th>
                                <th>Resort</th>
                                <th v-if="groups != null" :colspan="groups.length" class="text-center">Grupos de actividad</th>
                                <th v-else>Grupos de actividad</th>
                                <th>Configurar</th>
                            </tr>
                            <tr>
                                <th></th>
                                <th></th>
                                <th v-if="groups.length == 0"></th>
                                <th v-for="(group, idx) in groups" :key="group.id">
                                    <div class="d-flex justify-content-between">
                                        <div>
                                            <div>
                                                {{group.name}} 
                                            </div>
                                            <admin-hotel-stop-group-check :points="hotelStopGroups" :group="group" :idx="idx" />
                                        </div>
                                        <div class="mb-1 d-flex">
                                            <b-dropdown
                                                size="lg"
                                                variant="link"
                                                toggle-class="text-decoration-none"
                                                class="float-right align-self-end"
                                                no-caret
                                            >
                                                <template v-slot:button-content>
                                                    <i class="fa fa-ellipsis-v"></i>
                                                </template>
                                                <fragment v-for="grp in groups" :key="grp.id">
                                                    <b-dropdown-item v-if="grp.id != group.id" @click="copy(group.id, grp.id)">
                                                        <div>
                                                            <i class="fa fa-plus-circle mr-2 fa-fw"/>({{grp.id}}) Copiar desde {{grp.name}}
                                                        </div>
                                                    </b-dropdown-item>
                                                </fragment>
                                                <b-dropdown-item @click="showBulkPickupEdit(suprazone, group, null)">
                                                    <div class="">
                                                        <i class="fa fa-wrench mr-2 fa-fw"/>Asignar misma parada
                                                    </div>
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="executeReset(group.id)">
                                                    <div class="text-danger">
                                                        <i class="fa fa-times-circle mr-2 fa-fw"/>Reset
                                                    </div>
                                                </b-dropdown-item>
                                            </b-dropdown>
                                            
                                        </div>
                                    </div>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody v-if="points.length > 0">
                            <admin-hotel-stop-groups-table-row 
                                :item="entry" :selectedSuprazone="suprazone_id"
                                v-for="(entry, idx) in points"
                                :key="idx"
                            />
                        </tbody>
                        <tbody v-else-if="points.length == 0 && suprazone_id > 0">
                            <tr>
                                <td colspan="3">
                                    No hay entradas
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else-if="suprazone_id == 0">
                            <tr>
                                <td colspan="3">
                                    Seleccione la zona en el desplegable
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <admin-hotel-stop-groups-assign-pickup-modal></admin-hotel-stop-groups-assign-pickup-modal>
                <admin-hotel-stop-groups-edit-modal :suprazone="suprazone" />
            </div>
        </div>
    </div>
</template>



<script>
/* eslint-disable */
import AdminHotelStopGroupsTableRow from './AdminHotelStopGroupsTableRow'
import AdminHotelStopGroupsEditModal from './AdminHotelStopGroupsEditModal.vue';
import AdminHotelStopGroupCheck from './AdminHotelStopGroupCheck';
import AdminHotelStopGroupsAssignPickupModal from './AdminHotelStopGroupsAssignPickupModal'

import { mapGetters } from "vuex";
import utils from '../../../utils/utils'
import _ from 'lodash';
import { Fragment } from 'vue-fragment'

export default {
    components: {
        AdminHotelStopGroupsTableRow,
        AdminHotelStopGroupsEditModal,
        AdminHotelStopGroupCheck,
        AdminHotelStopGroupsAssignPickupModal,
        Fragment
    },
    data: function () {
        return {
            loadingSync: false,
            suprazone_id: 0,
            suprazone: {},
            groups: [],
            points: [], // this.hotelStopGroups,
            filtering: {
                filter_name: '',
                filterPoints: 'todo',
                orderPoints: 'by_hotel_name',
                resort: 0
            }
        }
    },
    mixins: [utils],
    methods: {},
    computed: {
        ...mapGetters(["hotelStopGroups", "suprazoneAdminCurrent", "groupsListAdmin", "suprazones", "subzonesListAdmin", 'forceUIReload', 'isDataLoading', 'isLoading']),
        grouping() {
            let g = _.mapValues(
                _.groupBy(
                    this.subzonesListAdmin, 'pickup_zone.name'
                ),
            )
            return g
        }
    },
    async mounted() {
        this.loadingSync = true
        // load all suprazones in the system
        await this.$store.dispatch("suprazones/loadSuprazones")
        if ( this.suprazone_id != null && this.suprazone_id > 0) {
            await this.trigger()
        }
        this.loadingSync = false
    },
    methods: {
        async trigger() {
            this.loadingSync = true
            this.points = this.hotelStopGroups
            this.groups = []
            await this.$store.dispatch("suprazones/loadSuprazones")
            if ( this.suprazone_id > 0) {
                this.suprazone = this.suprazoneAdminCurrent(this.suprazone_id)
                const input_data = {suprazone_id: this.suprazone_id}
                await this.$store.dispatch('subzones/getSubzonesBySuprazone', input_data)
                await this.$store.dispatch('groups/loadGroupsBySuprazone', input_data)
                await this.$store.dispatch("hotelStopGroups/getHotelStopGroupsBySuprazone", input_data)
                this.points = this.hotelStopGroups
                // TODO ensure activity groups are ordered by id
                this.groups = this.sortArrayOfObjects(this.groupsListAdmin, 'id')
                this.groups = this.groups.filter((g) => g.manage == true)
                this.triggerFiltering()
                this.order()
            }
            this.loadingSync = false
        },
        onFilterHotelName() {
            if ( this.filtering.filter_name.length > 1) {
                this.points = this.points.filter( 
                    item => item.hotel.name.toLowerCase().includes(this.filtering.filter_name)
                )
            }
            // } else if ( this.filtering.filter_name.length <= 1 ) {
            //     this.points = this.geopointsListAdmin
            // }
        },
        order() {
            if ( this.filtering.orderPoints == 'by_zone_name') {

                function sortPoints(points) {
                    const order = ({ hotel }) => hotel.sub_zone.name;
                    points.sort((a, b) => {
                        if ( order(a) < order(b) ) return -1
                        if ( order(a) > order(b) ) return 1
                        return 0
                    } );

                    return points;
                }
                this.points = sortPoints(this.points)
            }
            else if ( this.filtering.orderPoints == 'by_hotel_name' ) {
                this.points = this.points.sort((a, b) => {
                    const geoNameA = a.hotel.name.toUpperCase()
                    const geoNameB = b.hotel.name.toUpperCase()
                    if ( geoNameA < geoNameB ) {
                        return -1
                    }
                    if ( geoNameA > geoNameB ) {
                        return 1
                    }
                    return 0
                })
            }
        },
        filterResort() {
            console.log('trigger filtering results')
            if ( this.filtering.resort > 0 ) {
                this.points = this.points.filter((item) => {
                    if ( item.hotel != null && item.hotel.sub_zone != null )
                        return item.hotel.sub_zone.id == this.filtering.resort
                    return false
                })
            }
        },
        filter() {

        },
        triggerFiltering() {
            this.points = this.hotelStopGroups
            this.filter()
            this.onFilterHotelName()
            this.filterResort()
            this.order()
        },
        async copy(to, from) {
            console.log('copiar desde - a', to, from)
            const data = {
                activity_group_from_id: from,
                activity_group_to_id: to
            }
            await this.$store.dispatch('hotelStopGroups/copyFromGroup', data)
            this.$notify({
                group: "foo",
                title: "Copia satisfactoria",
                text: "Toda la configuración ha sido copiada al grupo de actividades destino",
                type: "success",
            });
        },
        async executeReset(groupId) {
            const data = {
                activity_group_id: groupId
            }
            await this.$store.dispatch('hotelStopGroups/reset', data)
            this.$notify({
                group: "foo",
                title: "Grupo de actividades reseteado",
                text: "Se ha reseteado completamente el grupo de actividades seleccionado",
                type: "success",
            });
        },
        async showBulkPickupEdit(suprazone, activity_group, pickup_point) {
            console.log('show modal bluk pikcup edit', suprazone.id, activity_group.id)
            const data = {
                suprazone: suprazone,
                activity_group: activity_group,
                pickup_point: null
            }
            console.log('data', data)
            await this.$store.dispatch("hotelStopGroups/storeGroupBulkPickupEdit", data)
            this.$bvModal.show('bulkEditPickup')
        }
    },
    watch: {
        filtering: {
            handler: function() {
                this.triggerFiltering()
                console.log('trigger filtering')
            },
            deep:true
        },
        forceUIReload: {
            handler: async function(val, oldVal) {
                console.log("watch forceUIReload")
                if ( val != oldVal && val == true ) {
                    console.log('trigger reload on points update')
                    this.trigger()
                    // this.loadingSync = true
                    // this.points = []
                    // const input_data = {suprazone_id: this.suprazone_id}
                    // await this.$store.dispatch("hotelStopGroups/getHotelStopGroupsBySuprazone", input_data)
                    // this.triggerFiltering()
                    this.$store.dispatch('hotelStopGroups/forceUIReload', {value: false})
                    // this.loadingSync = false
                }
            },
            deep: true
        },
        suprazone_id: {
            handler: function() {
                this.points = []
                this.$store.commit('hotelStopGroups/RESET_HOTEL_STOPS_GROUPS')
            }
        }
    },
    beforeDestroy() {
        this.$store.commit('hotelStopGroups/RESET_HOTEL_STOPS_GROUPS')
    }
}
</script>

<style scoped>
th {
    position: sticky;
    top: 50px;
}
</style>